module.exports = __webpack_public_path__ + "img/hn.b99d1caa.png";